import userActionTypes from "./user.types";
const INITIAL_STATE = {
  userData: {
    _id: null,
    creator: null,
    active: null,
    dbse: null,
    email: null,
    id: null,
    name: null,
    role: null,
    stoken: null,
    firstName: null,
    lastName: null,
    pictureSmall: null,
    pictureBig: null,
    coins: 0,
    country: null,
    preferredCurrency: null,
  },

  token: null,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userActionTypes.UPDATE_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        userData: {
          ...state.userData,
          firstName: action.payload.firstName,
          lastName: action.payload.lastName,
        },
      };
    case userActionTypes.UPLOAD_USER_PHOTOS_SUCCESS:
      return {
        ...state,
        userData: {
          ...state.userData,
          pictureSmall: action.payload.photoSmall,
          pictureBig: action.payload.photoBig,
        },
      };
    case userActionTypes.FETCH_USER_COINS_SUCCESS:
      return {
        ...state,
        userData: {
          ...state.userData,
          coins: action.payload,
        },
      };
    case userActionTypes.UPDATE_USER_LOCATION:
      return {
        ...state,
        userData: {
          ...state.userData,
          country: action.payload.country,
          preferredCurrency: action.payload.preferredCurrency,
        },
      };
    case userActionTypes.LOG_IN_SUCCESS:
    case userActionTypes.VERIFY_EMAIL_SUCCESS:
    case userActionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        userData: {
          ...state.userData,
          _id: action.payload.userData._id,

          active: action.payload.userData.active,

          creator: action.payload.userData.creator,

          dbse: action.payload.userData.dbse,

          email: action.payload.userData.email,

          id: action.payload.userData.id,

          name: action.payload.userData.name,

          role: action.payload.userData.role,

          stoken: action.payload.userData.stoken,

          firstName: action.payload.userData.firstName,

          lastName: action.payload.userData.lastName,

          pictureSmall: action.payload.userData.photoSmall,
          pictureBig: action.payload.userData.photoBig,
          country: action.payload.userData.country,
          preferredCurrency: action.payload.userData.preferredCurrency,
        },
        token: action.payload.token,
      };

    case userActionTypes.SIGN_OUT_SUCCESS:
    case userActionTypes.SIGN_OUT_FAILURE:
      return INITIAL_STATE;

    case userActionTypes.SYNC_USER_DATA_SUCCESS:
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default userReducer;
